import {
  getAllCountries,
  checkEligbiltyForBundleGifting,
  getBundles,
  checkIsPlusEligible,
  getComboProducts,
  getCountryBundlesV2,
  getFamilyRoamingCountries,
  getFamilyRoamingCountryBundles,
  getGroups,
  createGroup,
  updateGroup,
  deleteGroup,
} from '../../api/bundle/index'
import { getTopServiceInVASSection } from '../../api/services/index'
import {
  SET_ALL_COUNTRIES,
  SET_BUNDLES,
  // eslint-disable-next-line prettier/prettier
  SET_TOP_SERVICE_IN_VAS,
  SET_IS_ELIGIBLE_FOR_NEW_GIFTING,
  SET_BUNDLE_GIFTING_DEST_MSISDN,
  SET_PLUS_ELIGIBLE,
  SET_COMBO_PRODUCTS,
  SET_COUNTRY_BUNDLES_V2,
  SET_GROUPS,
} from './actionTypes'

export const getBundlesData = async (dispatch) => {
  dispatch(setBundles({ isLoading: true }))
  const res = await getBundles()
  dispatch(setBundles(res))
}
export const getCountriesData = async (dispatch) => {
  const res = await getAllCountries()
  dispatch(setCountriesData(res))
}
export const getTopServiceData = async (dispatch) => {
  const res = await getTopServiceInVASSection()
  dispatch(setTopServiceDataInVAS(res))
}

export const checkEligbiltyForNewGifting = async (dispatch) => {
  const res = await checkEligbiltyForBundleGifting()
  dispatch(setEligbiltyForNewGifting(res))
}

export const getIsPlusEligible = async (dispatch) => {
  const storedCustomerType = localStorage.getItem('customerType')
  if (storedCustomerType) {
    try {
      const parsedType = JSON.parse(storedCustomerType)
      if (parsedType === 1 || parsedType === 2) {
        dispatch(
          setIsPlusEligible({
            isLoading: false,
            status: 'notApplicable',
            message: 'Service not available for fixed line customers',
          })
        )
        return
      }
    } catch (error) {
      // Ignore parse errors and proceed with API call
    }
  }
  dispatch(setIsPlusEligible({ isLoading: true }))
  const res = await checkIsPlusEligible()
  dispatch(setIsPlusEligible(res))
}

export const getComboProductsFromApi = async (dispatch) => {
  dispatch(setComboProducts({ isLoading: true }))
  const res = await getComboProducts()
  dispatch(setComboProducts(res))
}

export const getCountryBundlesV2Data = async (dispatch, countryCodes) => {
  dispatch(setCountryBundlesV2({ isLoading: true }))
  const res = await getCountryBundlesV2(countryCodes)
  dispatch(setCountryBundlesV2(res))
}

export const getFamilyRoamingCountriesData = async (dispatch, destMsisdn) => {
  dispatch(setCountriesData({ isLoading: true }))
  const res = await getFamilyRoamingCountries(destMsisdn)
  dispatch(setCountriesData(res))
}

export const getFamilyRoamingCountryBundlesData = async (dispatch, destMsisdn, countryCodes) => {
  dispatch(setCountryBundlesV2({ isLoading: true }))
  const res = await getFamilyRoamingCountryBundles(destMsisdn, countryCodes)
  dispatch(setCountryBundlesV2(res))
}

// Groups actions
export const getGroupsData = async (dispatch) => {
  dispatch(setGroups({ isLoading: true }))
  const res = await getGroups()
  dispatch(setGroups(res))
}

export const createGroupData = async (dispatch, groupData) => {
  console.log('Redux createGroupData called with:', groupData)
  const res = await createGroup(groupData)
  console.log('Redux createGroupData result:', res)
  if (res.groupId) {
    // Refresh groups list after successful creation
    await getGroupsData(dispatch)
  }
  return res
}

export const updateGroupData = async (dispatch, groupData) => {
  const res = await updateGroup(groupData)
  if (res.success) {
    // Refresh groups list after successful update
    await getGroupsData(dispatch)
  }
  return res
}

export const deleteGroupData = async (dispatch, groupId) => {
  const res = await deleteGroup(groupId)
  if (res.success) {
    // Refresh groups list after successful deletion
    await getGroupsData(dispatch)
  }
  return res
}

export const setBundles = (bundlesData) => ({
  type: SET_BUNDLES,
  payload: bundlesData,
})
export const setCountriesData = (countriesData) => ({
  type: SET_ALL_COUNTRIES,
  payload: countriesData,
})
export const setTopServiceDataInVAS = (topServiceInfo) => ({
  type: SET_TOP_SERVICE_IN_VAS,
  payload: topServiceInfo,
})

export const setEligbiltyForNewGifting = (eligible) => ({
  type: SET_IS_ELIGIBLE_FOR_NEW_GIFTING,
  payload: eligible,
})

export const setBundleGiftingDestMsisdn = (destMsisdn) => ({
  type: SET_BUNDLE_GIFTING_DEST_MSISDN,
  payload: destMsisdn,
})

export const setIsPlusEligible = (eligible) => ({
  type: SET_PLUS_ELIGIBLE,
  payload: eligible,
})
export const setComboProducts = (products) => ({
  type: SET_COMBO_PRODUCTS,
  payload: products,
})

export const setCountryBundlesV2 = (bundlesData) => ({
  type: SET_COUNTRY_BUNDLES_V2,
  payload: bundlesData,
})

export const setGroups = (groupsData) => ({
  type: SET_GROUPS,
  payload: groupsData,
})
